import React from 'react';
import { Card, CardProps } from '@mui/material';
import { BG_COLORS, BORDER_COLORS } from '../../utils/colors';

interface GlassCardProps extends CardProps {
  hoverEffect?: boolean;
}

const GlassCard: React.FC<GlassCardProps> = ({
  hoverEffect = true,
  sx,
  children,
  ...props
}) => {
  const baseStyles = {
    background: BG_COLORS.GLASS,
    border: `1px solid ${BORDER_COLORS.LIGHT}`,
    transition: 'all 0.3s ease',
    // Disable backdrop-filter to prevent rendering artifacts (blur is already on parent GlassContainer)
    backdropFilter: 'none',
    // GPU rendering fixes
    transform: 'translateZ(0)',
    backfaceVisibility: 'hidden' as const,
    WebkitBackfaceVisibility: 'hidden' as const,
  };

  const hoverStyles = hoverEffect ? {
    '&:hover': {
      transform: 'translateY(-4px) translateZ(0)',
      borderColor: 'rgba(185, 28, 28, 0.6)',
      background: BG_COLORS.GLASS_LIGHTER,
    },
  } : {};

  return (
    <Card
      {...props}
      sx={{
        ...baseStyles,
        ...hoverStyles,
        ...sx,
      }}
    >
      {children}
    </Card>
  );
};

export default GlassCard;
